import { Component, OnInit, ViewChildren, QueryList, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseConhecimentoDTO } from '../base-conhecimento.dto';
import { BaseConhecimentoService } from '../base-conhecimento.service';
import { CategoriaDefinicao, CategoriaEnum, CATEGORIAS_INFO, MAPA_IDS_API } from './categorias-base-conhecimento.const';
import {ConfirmDialogOptions, MensagensService} from 'max-ng-lib';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'rot-dialog-base-conhecimento',
  templateUrl: './dialog-base-conhecimento.component.html',
  styleUrls: ['./dialog-base-conhecimento.component.scss']
})
export class DialogBaseConhecimentoComponent implements OnInit, AfterViewInit, OnDestroy {
  carregando = false;
  termoPesquisa = '';

  isProducao = environment.production;

  produtos = [
    { id: 'maxMotorista', descricao: 'maxMotorista' },
    { id: 'maxRoteirizador', descricao: 'maxRoteirizador' },
    { id: 'maxTMS', descricao: 'maxTMS' }
  ];
  produtoSelecionado = 'maxRoteirizador';

  itemInicio = CATEGORIAS_INFO.INICIO;
  indique = CATEGORIAS_INFO.INDIQUE;
  compartilheopiniao = CATEGORIAS_INFO.COMPARTILHE_OPINIAO;

  categoriaSelecionada: CategoriaDefinicao | null = null;
  categoriasAtuais: CategoriaDefinicao[] = [];

  paginas: (BaseConhecimentoDTO & { isLoadingDesc?: boolean })[] = [];
  paginasFiltradas: (BaseConhecimentoDTO & {isLoadingDesc?: boolean })[] = [];

  @ViewChildren('cardElement') cardElements!: QueryList<ElementRef>;
  private observer: IntersectionObserver | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogBaseConhecimentoComponent>,
    private conhecimentoService: BaseConhecimentoService,
    private mensagemService: MensagensService
  ) {}

  ngOnInit(): void {
    this.atualizarListaDeCategorias();
    this.selecionarCategoria(this.itemInicio);
  }

  ngAfterViewInit(): void {
    this.cardElements.changes.subscribe(() => {
      this.configurarIntersectionObserver();
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  fecharModal(): void {
    this.dialogRef.close();
  }

  aoMudarProduto(): void {
    this.atualizarListaDeCategorias();

    if (this.categoriaSelecionada &&
      this.categoriaSelecionada.id !== CategoriaEnum.INICIO &&
      this.categoriaSelecionada.id !== CategoriaEnum.INDIQUE) {

      const idAtual = this.categoriaSelecionada.id;
      const categoriaEquivalente = this.categoriasAtuais.find(c => c.id === idAtual);

      this.selecionarCategoria(categoriaEquivalente || this.itemInicio);
    }
  }

  atualizarListaDeCategorias(): void {
    const mapaProduto = MAPA_IDS_API[this.produtoSelecionado] || {};
    const idsParaOProduto = Object.keys(mapaProduto);
    this.categoriasAtuais = idsParaOProduto.map(id => CATEGORIAS_INFO[id]);
  }

  selecionarCategoria(categoria: CategoriaDefinicao): void {
    if (categoria.id === CategoriaEnum.COMPARTILHE_OPINIAO) {
      window.open('https://forms.office.com/r/q9KwAv1H15', '_blank');
      return;
    }

    this.categoriaSelecionada = categoria;

    if (categoria.id === CategoriaEnum.INICIO || categoria.id === CategoriaEnum.INDIQUE) {
      this.paginas = [];
      this.paginasFiltradas = [];
      return;
    }

    this.buscarDados();
  }

  buscarDados(): void {
    this.carregando = true;
    this.paginas = [];
    this.paginasFiltradas = [];

    const mapaProduto = MAPA_IDS_API[this.produtoSelecionado] || {};
    const apiId = mapaProduto[this.categoriaSelecionada.id];

    this.conhecimentoService.listarPaginas(apiId, this.categoriaSelecionada.exibirApenasComDescricao).subscribe(
      (dados) => {
        this.paginas = dados;
        this.filtrarPaginas();
        this.carregando = false;
      },
      (erro) => {
        console.error('Erro ao buscar base de conhecimento', erro);
        this.carregando = false;
      }
    );
  }

  private removerAcentos(str: string): string {
    if (!str) { return ''; }
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  filtrarPaginas(): void {
    if (!this.termoPesquisa || this.termoPesquisa.trim() === '') {
      this.paginasFiltradas = this.paginas;
      return;
    }

    const termoNormalizado = this.removerAcentos(this.termoPesquisa.trim().toLowerCase());
    this.paginasFiltradas = this.paginas.filter(p => {
      const tituloNormalizado = this.removerAcentos((p.titulo || '').toLowerCase());
      const descricaoNormalizada = this.removerAcentos((p.descricao || '').toLowerCase());

      return tituloNormalizado.includes(termoNormalizado)
        || descricaoNormalizada.includes(termoNormalizado);
    });
  }

  obterEstiloTag(pagina: any) {
    const cat = this.categoriasAtuais.find(c => c.nome === pagina.categoriaNome) || this.categoriaSelecionada;
    const cor = (cat && cat.cor) ? cat.cor : '#2f80ed';
    return {
      color: cor,
      'background-color': cor + '15'
    };
  }


  // --- LÓGICA DE LAZY LOADING DA DESCRIÇÃO ---
  private configurarIntersectionObserver(): void {
    if (this.observer) {
      this.observer.disconnect();
    }

    const options = {
      root: null,
      rootMargin: '0px 0px 300px 0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target as HTMLElement;
          const index = parseInt(el.getAttribute('data-index') || '-1', 10);

          if (index >= 0) {
            const pagina = this.paginasFiltradas[index];
            if (pagina && !pagina.descricao && !pagina.isLoadingDesc) {
              this.carregarDescricao(pagina);
              observer.unobserve(el);
            }
          }
        }
      });
    }, options);

    this.cardElements.forEach(el => this.observer.observe(el.nativeElement));
  }

  async carregarDescricao(pagina: any) {
    pagina.isLoadingDesc = true;

    try {
      const descricao = await this.conhecimentoService.obterDescricaoArtigo(pagina.id).toPromise();

      if (!descricao && this.categoriaSelecionada.exibirApenasComDescricao) {

        const indexFiltradas = this.paginasFiltradas.findIndex(i => i.id === pagina.id);
        const indexPaginas = this.paginas.findIndex(i => i.id === pagina.id);

        if (indexFiltradas !== -1) {
          this.paginasFiltradas.splice(indexFiltradas, 1);
        }

        if (indexPaginas !== -1) {
          this.paginas.splice(indexPaginas, 1);
        }

        return;
    }
      pagina.descricao = descricao || 'Clique para acessar a documentação detalhada.';
    } catch (error) {
      console.error('Falha ao obter descrição do artigo', error);
      pagina.descricao = '';
    } finally {
      setTimeout(() => {
        pagina.isLoadingDesc = false;
      }, 1000);
    }
  }

  excluirCache() {
    this.mensagemService.exibaConfirmDialog('Deseja realmente Excluir o Cache dos artigos?', '')
      .subscribe(result => {
        if (result.confirmDialogSelect === ConfirmDialogOptions.SIM) {
          this.conhecimentoService.excluirCacheArtigos().toPromise();
        }
      });
  }
}
